class LookbookInteractive {
  constructor(sliderId) {
    this.slider = document.getElementById(sliderId);
    if (!this.slider) return;
    
    this.slides = this.slider.querySelectorAll('.lookbook-interactive__slide');
    this.prevButton = this.slider.closest('.lookbook-interactive__container').querySelector('.lookbook-interactive__nav-button--prev');
    this.nextButton = this.slider.closest('.lookbook-interactive__container').querySelector('.lookbook-interactive__nav-button--next');
    this.currentSlideEl = this.slider.closest('.lookbook-interactive__container').querySelector('.lookbook-interactive__current-slide');
    this.totalSlidesEl = this.slider.closest('.lookbook-interactive__container').querySelector('.lookbook-interactive__total-slides');
    
    this.currentSlide = 0;
    this.init();
  }

  init() {
    if (this.slides.length === 0) return;
    
    this.showSlide(0);
    
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }

    // Touch/swipe support
    let startX = 0;
    let isDragging = false;
    
    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });
    
    this.slider.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });
    
    this.slider.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    });

    // Keyboard navigation
    this.slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        this.nextSlide();
      }
    });
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('lookbook-interactive__slide--active');
      } else {
        slide.classList.remove('lookbook-interactive__slide--active');
      }
    });
    
    this.currentSlide = index;
    
    if (this.currentSlideEl) {
      this.currentSlideEl.textContent = index + 1;
    }
    
    this.updateButtons();
  }

  nextSlide() {
    const next = (this.currentSlide + 1) % this.slides.length;
    this.showSlide(next);
  }

  prevSlide() {
    const prev = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.showSlide(prev);
  }

  updateButtons() {
    if (this.prevButton) {
      this.prevButton.disabled = this.slides.length <= 1;
    }
    if (this.nextButton) {
      this.nextButton.disabled = this.slides.length <= 1;
    }
  }
}

// Initialize all lookbook sliders
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[id^="lookbook-slider-"]');
  sliders.forEach(slider => {
    new LookbookInteractive(slider.id);
  });
});

// Reinitialize in theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('[id^="lookbook-slider-"]');
    if (slider) {
      new LookbookInteractive(slider.id);
    }
  });
}

